// extracted by mini-css-extract-plugin
export default {"title":"m_-z","warning":"n_-z","sizeOptionsLegendText":"o_-z"};